import React from 'react';
import Signature from 'components/global/Form/Signature/Signature';

// Reusa el componente de firma táctil (canvas + upload S3 propio). Guarda la
// key S3 (signatures/...) en el config del bloque.
function BloqueFirma({ block, onChange }) {
  const key = block.config?.specialistSignatureKey;
  return (
    <Signature
      role="spec"
      value={key}
      onChange={(k) => onChange({ config: { specialistSignatureKey: k } })}
    />
  );
}

export default BloqueFirma;
